import { useSettings } from "@/lib/settings";

export default function Marquee() {
  const { settings } = useSettings();
  const items = settings.texts.marquee_items || [];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="overflow-hidden border-y border-black/5 bg-[var(--brand-bg)] py-7" data-testid="marquee-section">
      <div className="marquee-track flex w-max items-center gap-24 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-24">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-24">
                <span className={`font-display text-3xl sm:text-4xl ${i % 2 ? "italic font-light text-[var(--brand-accent)]" : "text-[var(--brand-dark)]"}`}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand-accent)]/60" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
